<template>
    <div>
        <div id="add-category-modal" class="modal fade" tabindex="-1" role="dialog">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                        <h4 class="modal-title">Hantera kategorier</h4>
                    </div>
                    <div class="modal-body">
                        <div class="panel panel-default">
                            <div class="panel-heading">Lägg till kategori</div>
                            <div class="panel-body">
                                <div class="form-group">
                                    <label>Namn</label>
                                    <input
                                        v-model="categoryTitle"
                                        type="text"
                                        name="title"
                                        class="form-control"
                                    />
                                    <p class="help-block">
                                        När du skapat dina kategorier kan du stänga denna rutan och välja dem
                                        i listningen.
                                    </p>
                                </div>
                                <div class="form-group">
                                    <button
                                        @click.prevent="submitAddCategory"
                                        type="submit"
                                        class="btn btn-success"
                                    >
                                        Lägg till
                                    </button>
                                    <button
                                        type="button"
                                        class="btn btn-danger"
                                        data-dismiss="modal"
                                        aria-label="Close"
                                    >
                                        Stäng
                                    </button>
                                </div>
                                <div v-if="categoryError !== ''" class="alert alert-danger">
                                    <p>{{ categoryError }}</p>
                                </div>
                            </div>
                        </div>
                        <div class="panel panel-default">
                            <div class="panel-heading">Kategorier</div>
                            <ul class="list-group">
                                <li v-for="cat in categories" :key="cat.id" class="list-group-item">
                                    {{ cat.text
                                    }}<a
                                        @click.prevent="submitDeleteCategory(cat.id)"
                                        href="#"
                                        class="delete-category-link"
                                        ><span class="icon-cross"></span>Ta bort</a
                                    >
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <slot></slot>

        <div class="form-group">
            <label>Kategori</label>
            <select
                class="form-control blog-categories"
                name="categories[]"
                id="category-select"
                multiple
            ></select>
            <a @click.prevent="showAddCategoryModal()" href="#">Lägg till eller ta bort kategorier</a>
        </div>
    </div>
</template>

<script>
export default {
    props: ['preSelectedIds', 'preSelectedTitles'],

    mounted: function () {
        if (this.preSelectedIds && this.preSelectedTitles) {
            const tempIds = JSON.parse(this.preSelectedIds);

            const tempTitles = JSON.parse(this.preSelectedTitles);

            for (var i = 0; i < tempIds.length; i++) {
                var el = '<option value="' + tempIds[i] + '" selected>' + tempTitles[i] + '</option>';
                $('#category-select').append(el);
            }
        }

        $('#category-select').select2({
            multiple: true,
            ajax: {
                url: '/blogg/api/categories',
                dataType: 'json',
                type: 'GET',
                data: function (params) {
                    var queryParameters = {
                        term: params.term
                    };
                    return queryParameters;
                },
                processResults: function (data) {
                    return {
                        results: $.map(data, function (item) {
                            return {
                                text: item.text,
                                id: item.id
                            };
                        })
                    };
                }
            }
        });

        $('#category-select').select2('data', { id: 22, text: 'ny' });

        this.getCategories();
    },

    data: function () {
        return {
            categoryTitle: '',
            categoryError: '',
            categories: {}
        };
    },

    methods: {
        showAddCategoryModal: function () {
            $('#add-category-modal').modal('show');
        },

        getCategories: function () {
            var callback = function (err, res) {
                if (err) {
                    return;
                }
                this.categories = res.body;
                $('#category-select').trigger('change');
            };
            request.get('/blogg/api/categories').end(callback.bind(this));
        },

        submitAddCategory: function () {
            var callback = function (err, res) {
                if (err) {
                    this.categoryError = res.body.message;
                } else {
                    this.categoryError = '';
                    this.categoryTitle = '';
                    this.getCategories();
                }
            };
            request.post('/blogg/api/category').send({ title: this.categoryTitle }).end(callback.bind(this));
        },

        submitDeleteCategory: function (id) {
            var callback = function (err, res) {
                if (err) {
                    // Do nothing
                } else {
                    var selectedValues = $('#category-select').val();
                    if (selectedValues) {
                        selectedValues.splice(selectedValues.indexOf(id), 1);
                        $('#category-select').val(selectedValues).trigger('change');
                    }
                    this.getCategories();
                }
            };
            request.post('/blogg/api/category/delete').send({ category_id: id }).end(callback.bind(this));
        }
    }
};
</script>
